import './coyoteridgegolf/style';
import FormStructure from './coyoteridgegolf/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/includes.js